(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDialogController', MonitorDialogController);

    MonitorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Monitor'];

    function MonitorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.monitor.id !== null) {
                Monitor.update(vm.monitor, onSaveSuccess, onSaveError);
            } else {
                Monitor.save(vm.monitor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:monitorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
